/* MIREO — interactions */
(function () {
  "use strict";

  /* ---- Thème clair / sombre ---- */
  var root = document.documentElement;
  var KEY = "mireo-theme";
  var saved = localStorage.getItem(KEY);
  if (saved) root.setAttribute("data-theme", saved);

  function toggleTheme() {
    var next = root.getAttribute("data-theme") === "light" ? "dark" : "light";
    if (next === "dark") root.removeAttribute("data-theme");
    else root.setAttribute("data-theme", "light");
    localStorage.setItem(KEY, next);
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-theme-toggle]");
    if (t) { e.preventDefault(); toggleTheme(); }
  });

  /* ---- Menu mobile ---- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-nav-toggle]");
    if (!btn) return;
    var menu = document.querySelector("[data-nav-menu]");
    if (menu) {
      var open = menu.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    }
  });

  /* ---- Steppers quantité (add-ons page produit) ---- */
  document.addEventListener("click", function (e) {
    var plus = e.target.closest("[data-qty-plus]");
    var minus = e.target.closest("[data-qty-minus]");
    if (!plus && !minus) return;
    e.preventDefault();
    var wrap = (plus || minus).closest(".addon-pick__qty");
    var input = wrap ? wrap.querySelector("[data-addon-qty]") : null;
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = plus ? Math.min(20, v + 1) : Math.max(1, v - 1);
  });

  /* ---- Menus déroulants ---- */
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".nav__toggle-sub");
    if (toggle) {
      var item = toggle.closest(".nav__item");
      var open = item.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      return;
    }
    if (!e.target.closest(".has-dropdown")) {
      document.querySelectorAll(".nav__item.is-open").forEach(function (it) {
        it.classList.remove("is-open");
        var t = it.querySelector(".nav__toggle-sub");
        if (t) t.setAttribute("aria-expanded", "false");
      });
    }
  });

  /* ---- Animations au scroll ---- */
  var els = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && els.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("is-visible"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---- Compte à rebours promo (par visiteur, démarre à la 1re visite) ---- */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }
  document.querySelectorAll("[data-countdown]").forEach(function (el) {
    var hours = parseFloat(el.getAttribute("data-hours")) || 24;
    var key = "mireo-cd-" + (el.getAttribute("data-key") || "promo");
    var deadline = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!deadline || isNaN(deadline) || deadline <= now) {
      // 1re visite OU minuteur expiré : on (re)démarre une nouvelle échéance depuis l'heure de visite
      deadline = now + hours * 3600 * 1000;
      localStorage.setItem(key, deadline);
    }
    var hEl = el.querySelector("[data-h]"), mEl = el.querySelector("[data-m]"), sEl = el.querySelector("[data-s]");
    var expiredMsg = el.getAttribute("data-expired") || "Offre terminée";
    function tick() {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        el.classList.add("is-expired");
        var lab = el.querySelector(".countdown__label");
        if (lab) lab.textContent = expiredMsg;
        clearInterval(timer);
        return;
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---- Compteurs animés ---- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-count")) || 0;
    var dec = (target % 1 !== 0) ? 1 : 0;
    var dur = 1400, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toFixed(dec);
      if (p < 1) requestAnimationFrame(step); else el.textContent = target.toFixed(dec);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll("[data-count]");
  if ("IntersectionObserver" in window && counters.length) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animateCount(en.target); cio.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { cio.observe(c); });
  } else {
    counters.forEach(function (c) { c.textContent = c.getAttribute("data-count"); });
  }

  /* ---- Barre d'annonce (fermable) ---- */
  document.querySelectorAll("[data-announcement]").forEach(function (bar) {
    var key = "mireo-" + (bar.getAttribute("data-key") || "annc");
    if (localStorage.getItem(key) === "1") { bar.style.display = "none"; return; }
    var btn = bar.querySelector("[data-announcement-close]");
    if (btn) btn.addEventListener("click", function () { bar.style.display = "none"; localStorage.setItem(key, "1"); });
  });

  /* ---- Mini-panier (tiroir) AJAX ---- */
  var drawer = document.querySelector("[data-cart-drawer]");
  if (drawer) {
    var itemsEl = drawer.querySelector("[data-drawer-items]");
    var emptyEl = drawer.querySelector("[data-drawer-empty]");
    var footEl = drawer.querySelector("[data-drawer-foot]");
    var crossEl = drawer.querySelector("[data-drawer-cross]");
    var totalEl = drawer.querySelector("[data-drawer-total]");

    var money = function (cents, cur) {
      try { return (cents / 100).toLocaleString("fr-CH", { style: "currency", currency: cur || "CHF" }); }
      catch (e) { return (cents / 100).toFixed(2) + " " + (cur || "CHF"); }
    };
    var openDrawer = function () { drawer.classList.add("is-open"); drawer.setAttribute("aria-hidden", "false"); document.body.classList.add("drawer-open"); };
    var closeDrawer = function () { drawer.classList.remove("is-open"); drawer.setAttribute("aria-hidden", "true"); document.body.classList.remove("drawer-open"); };

    var renderCart = function (cart) {
      document.querySelectorAll("[data-cart-count]").forEach(function (b) {
        b.textContent = cart.item_count;
        if (cart.item_count > 0) b.removeAttribute("hidden"); else b.setAttribute("hidden", "");
      });
      if (!cart.item_count) {
        emptyEl.removeAttribute("hidden"); itemsEl.setAttribute("hidden", ""); footEl.setAttribute("hidden", "");
        if (crossEl) crossEl.setAttribute("hidden", ""); itemsEl.innerHTML = ""; return;
      }
      emptyEl.setAttribute("hidden", ""); itemsEl.removeAttribute("hidden"); footEl.removeAttribute("hidden");
      if (crossEl) crossEl.removeAttribute("hidden");
      var html = "";
      cart.items.forEach(function (it, i) {
        var src = it.image ? (it.image + (it.image.indexOf("?") >= 0 ? "&" : "?") + "width=120") : "";
        var img = src ? '<img src="' + src + '" alt="" width="56" height="56" loading="lazy">' : '<span class="drawer-item__ph"></span>';
        html += '<div class="drawer-item" data-line="' + (i + 1) + '">' + img +
          '<div class="drawer-item__info"><a href="' + it.url + '" class="drawer-item__title">' + it.product_title + '</a>' +
          '<div class="drawer-item__price">' + money(it.final_line_price, cart.currency) + '</div>' +
          '<div class="drawer-item__qty"><span class="drawer-item__stepper"><button type="button" data-qty-dec aria-label="Diminuer">−</button><span>' + it.quantity + '</span><button type="button" data-qty-inc aria-label="Augmenter">+</button></span>' +
          '<button type="button" class="drawer-item__remove" data-line-remove>Retirer</button></div></div></div>';
      });
      itemsEl.innerHTML = html;
      totalEl.textContent = money(cart.total_price, cart.currency);
    };

    var refresh = function (open) {
      return fetch("/cart.js", { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); if (open) openDrawer(); return cart; });
    };
    var addItems = function (items, open) {
      return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); }).then(function () { return refresh(open !== false); });
    };
    var changeLine = function (line, qty) {
      return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ line: line, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); return cart; });
    };

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-open]")) { e.preventDefault(); refresh(true); }
      if (e.target.closest("[data-drawer-close]")) closeDrawer();
      var cross = e.target.closest("[data-add-variant]");
      if (cross) { e.preventDefault(); var id = parseInt(cross.getAttribute("data-add-variant"), 10); if (id) addItems([{ id: id, quantity: 1 }], true); }
      var item = e.target.closest(".drawer-item");
      if (item) {
        var line = parseInt(item.getAttribute("data-line"), 10);
        var span = item.querySelector(".drawer-item__qty span");
        var cur = span ? parseInt(span.textContent, 10) : 1;
        if (e.target.closest("[data-qty-inc]")) changeLine(line, cur + 1);
        else if (e.target.closest("[data-qty-dec]")) changeLine(line, Math.max(0, cur - 1));
        else if (e.target.closest("[data-line-remove]")) changeLine(line, 0);
      }
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) { form.submit(); return; }
        var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
        form.querySelectorAll("[data-addon-variant]:checked").forEach(function (cb) {
          var aItem = cb.closest(".addon-pick__item");
          var qi = aItem ? aItem.querySelector("[data-addon-qty]") : null;
          var q = qi ? Math.min(20, Math.max(1, parseInt(qi.value, 10) || 1)) : 1;
          items.push({ id: parseInt(cb.getAttribute("data-addon-variant"), 10), quantity: q });
        });
        var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
        addItems(items, true).then(function () {
          if (btn) btn.disabled = false;
          form.querySelectorAll("[data-addon-variant]:checked").forEach(function (cb) { cb.checked = false; });
          form.querySelectorAll("[data-addon-qty]").forEach(function (qi) { qi.value = 1; });
        }).catch(function () { if (btn) btn.disabled = false; form.submit(); });
      });
    });

    refresh(false);
  }

  /* ---- FAQ : un seul ouvert à la fois (optionnel) ---- */
  document.querySelectorAll("[data-faq] details").forEach(function (d) {
    d.addEventListener("toggle", function () {
      if (d.open) {
        d.closest("[data-faq]").querySelectorAll("details[open]").forEach(function (o) {
          if (o !== d) o.open = false;
        });
      }
    });
  });

  /* ---- Sélecteur de variante (page produit) ---- */
  document.querySelectorAll("[data-variant-data]").forEach(function (node) {
    var form = node.closest("form");
    if (!form) return;
    var data;
    try { data = JSON.parse(node.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('select[name^="options"]');
    if (!selects.length) return;
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector("[data-price]");
    var btn = form.querySelector('[type="submit"]');
    function syncVariant() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = data.filter(function (x) {
        return x.options && x.options.length === chosen.length && x.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl && match.price) priceEl.textContent = match.price;
      if (btn) btn.disabled = !match.available;
    }
    Array.prototype.forEach.call(selects, function (s) { s.addEventListener("change", syncVariant); });
    syncVariant();
  });

  /* ---- Barre CTA mobile : "Ajouter au panier" déclenche le formulaire produit ---- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-sticky-add]");
    if (!b) return;
    e.preventDefault();
    var form = document.querySelector('form[action$="/cart/add"]');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
  });
})();
